import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Colors from '@/constants/colors';
import { DetailPageLayoutContext } from './DetailPageLayoutContext';

interface DetailPageHeaderProps {
  title: string;
}

export default function DetailPageHeader({ title }: DetailPageHeaderProps) {
  const navigate = useNavigate();
  const context = useContext(DetailPageLayoutContext);

  const handleBackClick = () => {
    if (context) {
      context.onBack();
      // Wait for animation to complete before navigating
      setTimeout(() => {
        navigate(-1);
      }, 350);
    } else {
      navigate(-1);
    }
  };

  return (
    <div style={styles.header}>
      <button
        style={styles.backButton}
        onClick={handleBackClick}
        aria-label="Go back"
      >
        <ArrowLeft size={24} color={Colors.text} />
      </button>
      <div style={styles.titleContainer}>
        <h1 style={styles.title}>{title}</h1>
      </div>
      <div style={styles.spacer} />
    </div>
  );
}

const styles = {
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 24px',
    borderBottom: `1px solid ${Colors.border}`,
    backgroundColor: Colors.surface,
    position: 'sticky' as const,
    top: 0,
    zIndex: 10,
  } as React.CSSProperties,

  backButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '40px',
    height: '40px',
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    borderRadius: '8px',
  } as React.CSSProperties,

  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flex: 1,
  } as React.CSSProperties,

  title: {
    fontSize: '22px',
    fontWeight: '700',
    color: Colors.text,
    margin: 0,
    textAlign: 'center' as const,
    flex: 1,
  } as React.CSSProperties,

  spacer: {
    width: '40px',
    height: '40px',
  } as React.CSSProperties,
};
